import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-empty-state-bird',
  templateUrl: './gb-empty-state-bird.component.html',
  styleUrls: ['./gb-empty-state-bird.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEmptyStateBirdComponent {}
